const php = `<?php
require 'vendor/autoload.php';

use WebSocket\Client;
//composer require textalk/websocket
// WebSocket URL
$path = 'wss://open-api-cswap-ws.bingx.com/market?listenKey=425f783f4a17cd65f4a5d7470cfd45a956dba0c29564aa4b70967bee4e4a8984';
$channel = 'https://open-api.bingx.com/openApi/user/auth/userDataStream';

try {
    // Initialize WebSocket client
    $client = new Client($path);

    // Send subscription message
    $client->send($channel);

    // Main loop to keep the connection open and process messages
    while (true) {
        $message = $client->receive(); // Receive message
        if ($message) {
            // Check if message is binary
            if (is_string($message)) {
                $decodedMsg = decodeGzip($message);
                echo "Received Binary Message: $decodedMsg\n";
                if (str_contains($decodedMsg, "ping")) {  
                    $client->send("pong");
                    echo "Sent pong\n";
                }
            } else {
                echo "Received Text Message: $message\n";
            }
        }

        // Send periodic ping messages
        $client->send("Ping");
        echo "Sent Ping\n";
        sleep(5); // 5 seconds
    }

} catch (Exception $e) {
    echo "Exception: " . $e->getMessage() . "\n";
}

// GZIP decoding function
function decodeGzip($compressedData) {
    $stream = gzopen('data://text/plain;base64,' . base64_encode($compressedData), 'rb');
    $decodedMessage = '';

    while (!gzeof($stream)) {
        $decodedMessage .= gzread($stream, 1024);
    }

    gzclose($stream);
    return $decodedMessage;
}`
export default  php



// WEBPACK FOOTER //
// ./src/utils/codeWs/cswap/php.js